import React from "react";
import { CLIENTS, AWARDS } from "../mock";

export default function Clients() {
  const doubled = [...CLIENTS, ...CLIENTS];

  return (
    <section id="clients" className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              (05) — Ils nous font confiance
            </span>
            <h2 className="font-display font-medium text-4xl md:text-6xl mt-6 leading-[1.02] tracking-[-0.03em]">
              Ils grandissent <span className="font-serif-i text-white/60">avec nous.</span>
            </h2>
          </div>
          <div className="font-mono text-xs text-white/40 max-w-xs">
            De la start-up B2B au groupe international. Toutes tailles, toutes catégories.
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative py-6 border-y border-white/10 bg-black/30 backdrop-blur-sm">
        <div className="marquee-track">
          {doubled.map((c, i) => (
            <div
              key={i}
              className="font-display text-3xl md:text-5xl font-medium tracking-[-0.02em] px-8 md:px-14 whitespace-nowrap text-white/80 hover:text-[#FF5B24] transition-colors"
            >
              {c}
              <span className="text-[#FF5B24] mx-6">•</span>
            </div>
          ))}
        </div>
      </div>

      {/* Awards */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mt-24">
        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              France 2025 — YouGov
            </span>
            <h3 className="font-display text-3xl md:text-5xl font-medium mt-4 tracking-[-0.02em]">
              Top 10 <span className="font-serif-i text-white/60">most-improved</span> brands.
            </h3>
            <p className="text-white/60 mt-6 max-w-sm">
              Deux de nos marques figurent dans le classement des marques dont la recommandation a le plus
              progressé en France.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="border border-white/10 rounded-lg overflow-hidden">
              <div className="grid grid-cols-12 px-4 md:px-6 py-3 bg-black/40 backdrop-blur-sm font-mono text-[10px] uppercase tracking-widest text-white/50">
                <div className="col-span-1">#</div>
                <div className="col-span-5">Brand</div>
                <div className="col-span-3 text-right">2025</div>
                <div className="col-span-3 text-right">Increase</div>
              </div>
              {AWARDS.map((a) => (
                <div
                  key={a.rank}
                  className={`grid grid-cols-12 px-4 md:px-6 py-4 items-center border-t border-white/5 transition-colors ${
                    a.highlight ? "bg-[#FF5B24]/5" : ""
                  }`}
                >
                  <div className="col-span-1 font-mono text-white/60 text-sm">{String(a.rank).padStart(2, "0")}</div>
                  <div
                    className={`col-span-5 font-display text-lg md:text-xl ${
                      a.highlight ? "text-[#FF5B24] font-medium" : "text-white"
                    }`}
                  >
                    {a.brand}
                    {a.highlight && (
                      <span className="ml-2 font-mono text-[9px] uppercase tracking-widest text-[#FF5B24]/80">
                        • Sup.
                      </span>
                    )}
                  </div>
                  <div className="col-span-3 text-right text-white/70">{a.score2025}</div>
                  <div
                    className={`col-span-3 text-right font-medium ${
                      a.highlight ? "text-[#FF5B24]" : "text-white/80"
                    }`}
                  >
                    {a.increase}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
